import * as lib from '../lib'
import { IFetchItems, IFetchListSpendBuyer } from '../types'

export const listAccountBuyer = async (
	signal: AbortSignal,
	token?: string | null,
): Promise<IFetchItems<IFetchListSpendBuyer>> => {
	const headers = lib.bearer(token)
	const method: string = 'GET'
	const params: lib.FetchOptions['params'] = {
		f: lib.filterSetup([]),
		s: lib.sortSetup([['role.teamReport', 'asc'], ['isFired', 'asc'], ['id', 'asc']]),
		skip: lib.skipSetup(0),
		take: lib.takeSetup('all'),
	}
	const uri: string = 'account/buyers'

	const options: lib.FetchOptions = {
		headers,
		method,
		params,
		signal,
	}
	const data = await lib.fetching<IFetchItems<IFetchListSpendBuyer>>(uri, options)

	return {
		items: data?.items ?? [],
		total: data?.items?.length ?? 0
	}
}
